<template>
  <div class="__C_Panel">
    <q-card :style="{ 'min-height': minHeight }" style="position: relative">
      <q-linear-progress indeterminate style="position: absolute; z-index: 5000" v-if="loading" />

      <q-card-section>
        <div class="inner" :class="{ 'no-padding': noPadding }">
          <slot />
        </div>
      </q-card-section>

      <div class="__C_Panel-Overlay" v-if="loading" />
    </q-card>
  </div>
</template>

<script>
import CLoading from '@/components/uikit/CLoading';
export default {
  name: 'CPanel',
  components: { CLoading },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    minHeight: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.q-card::v-deep {
  .q-card__section {
    padding: 0;
  }
}

.inner {
  padding: $space-md;

  &.no-padding {
    padding: 0;
  }
}

.__C_Panel {
  position: relative;
  min-height: 80px;
  padding: $space-xs;

  &-Overlay {
    position: absolute;
    background-color: #fff;
    height: 100%;
    width: 100%;
    top: 0;
    border-radius: $border-radius !important;
  }
}
</style>
